module.exports = __webpack_public_path__ + "myMideaLink.03479458.jpg";